Element.prototype.text = function (text) {
  if (text === undefined) {
    return this.textContent;
  } else {
    this.textContent = text;
    return this;
  }
};

Element.prototype.select = function (selector) {
  return this.querySelector(selector);
};

Element.prototype.selectAll = function (selector) {
  const elems = this.querySelectorAll(selector);
  return Array.from(elems);
};

Element.prototype.attr = function (name, value) {
  if (value === undefined) {
    return this.getAttribute(name);
  } else if (value === null) {
    this.removeAttribute(name);
    return this;
  }
  this.setAttribute(name, value);
  return this;
};

Element.prototype.append = function (name) {
  const newElem = document.createElementNS(this.namespaceURI, name);
  this.appendChild(newElem);
  return newElem;
};

Element.prototype.addFirstChild = function (name) {
  const newElem = document.createElementNS(this.namespaceURI, name);
  this.prepend(newElem);
  return newElem;
};

Element.prototype.call = function (cb) {
  cb(this);
  return this;
};

Element.prototype.remove = function () {
  if (this.parentNode == null) {
    console.warn("Element has no parent");
    return this;
  }
  this.parentNode.removeChild(this);
  return this;
};
